module.exports = __webpack_public_path__ + "static/logo15-76fc2301f1373b181a786cd39c0eafed.png";